import {Alert} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleExclamation, faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";

type AlertWarningProps = {
    children: any;
};
const AlertWarning = (props: AlertWarningProps) => {
    return (
        <Alert variant="warning" className="d-flex align-items-center">
            <FontAwesomeIcon icon={faCircleExclamation} size="2x" className="me-3"/>
            <p className="mb-0">{props.children}</p>
        </Alert>
    );
}
export default AlertWarning;